import bannerImg from './../../images/scv_banner.jpg';
import "./banner.css";

const Banner = () => {
  return (
    <div role='banner' id="banner-con">
      <div id="banner">
        <img id='banner-img'
          alt="Virginia's Judicial System banner"
          src={bannerImg}
        />
      </div>
      <div id="banner-bar" aria-hidden="true"></div>
      <div id="shadow" aria-hidden="true"></div>
    </div>
  );
};

export default Banner;
